import React from 'react';
export class ContextWrapper<T>{
    private context!: React.Context<T>;

    constructor(contextType?: T) {
        if (contextType)
            this.set(contextType);
    }

    set(value: T) {
        this.context = React.createContext<T>(value);
    }
    get() {
        return this.context;
    }
}
